import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let employersSwiperWr = document.querySelectorAll('.employers-swiper-wr');
employersSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let loop = false;
    let loopedSlides = false;

    if (slidesCount >= 6) {
      loop = true;
      loopedSlides = slidesCount * 2;
    }

    const updateWrapperClass = (slidesPerView) => {
      if (slidesCount > slidesPerView) {
        wrapper.classList.remove('justify-center');
      } else {
        wrapper.classList.add('justify-center');
      }
    };


    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 3,
      loop: loop,
      loopedSlides: loopedSlides,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        451: {
          slidesPerView: 3,
          on: {
            beforeInit: function () {
              updateWrapperClass(3);
            },
          },
        },
        640: {
          slidesPerView: 4,
          on: {
            beforeInit: function () {
              updateWrapperClass(4);
            },
          },
        },
        801: {
          slidesPerView: 5,
          on: {
            beforeInit: function () {
              updateWrapperClass(5);
            },
          },
        },
        1024: {
          slidesPerView: 6,
          on: {
            beforeInit: function () {
              updateWrapperClass(6);
            },
          },
        },
        1200: {
          slidesPerView: 7,
          on: {
            beforeInit: function () {
              updateWrapperClass(7);
            },
          },
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });

    swiper.on('breakpoint', (swiper) => {
      updateWrapperClass(swiper.params.slidesPerView);
    });

    updateWrapperClass(swiper.params.slidesPerView);

    swiperObserver(swiper);
  }
});
